import $ from 'jquery';
import {Invoice} from './Invoice';
import InvoiceFeeTable from './InvoiceFeeTable';
import InvoiceLineTable from './InvoiceLineTable';

class InvoiceForm {

  isInvoiceForm() {
    return this.$form.length > 0;
  }

  init() {
    this.$form = $('#invoice_form');
    this.formInitialized = false;

    if (this.isInvoiceForm()) {
      this.initData();
      this.initForm();
      this.setupEvents();
      this.formInitialized = true;
    }
  }

  initData() {
    let data = $('#invoice_data').data('json') || {};
    if (data.fee_schedule === undefined || data.fee_schedule === null) {
      data.fee_schedule = {'ranges': [], 'fees': []};
    } else {
      if (data.fee_schedule.ranges === undefined) data.fee_schedule.ranges = [];
      if (data.fee_schedule.fees === undefined) data.fee_schedule.fees = [];
    }
    if (data.invoice.fees === undefined) data.invoice.fees = [];
    if (data.invoice.lines === undefined) data.invoice.lines = [];
    this.invoice = new Invoice(data);
  }

  initForm() {
    this.feeTable = new InvoiceFeeTable(this);
    this.feeTable.init();
    this.lineTable = new InvoiceLineTable(this);
    this.lineTable.init();
  }

  setupEvents() {
    let _this = this;

    $('#adjuster_id').on('change', function(e) {
      let $sel = $(this);
      let id = $sel.val();
      let rate = _this.invoice.adjuster_rates[id] || 65;
      $('#adjuster_rate').val(rate);
      _this.calculateTotal();
    });

    $('#fee_schedule_id').on('change', function(e) {
      let $sel = $(this);
      let id = $sel.val();

      axios.get('/webapi/fee-schedules/' + id)
        .then(function (response) {
          let data = response.data.data;

          _this.updateFeeScheduleBasedItems(data);

          $('#admin_fee').val(data.admin_fee);
          $('#holdback').val(data.holdback);
          $('#discount').val(data.discount);
          _this.invoice.resetFeeScheduleData(data);
          _this.feeTable.buildRows();
          _this.calculateTotal();
        })
        .catch(function (error) {
          $sel.val($sel.data('fee_schedule_id'))
            .trigger('chosen:updated');
        });
    });

    // Listen for examiner fee radio button selection change
    $('input[name="examiner_fee"]').change(function() {
      const selectedValue = $('input[name="examiner_fee"]:checked').val();
      $('#pay_examiner_status').val(selectedValue);
    });

    $(document).ready(function() {
      let examinerId = $('#examiner_id').val() ? $('#examiner_id').val() : 0;
      let feeScheduleId = $('#fee_schedule_id').val() ;
      let pay_examiner = $('#pay_examiner_status').val();
      pay_examiner = pay_examiner.length === 0 ? pay_examiner : Number(pay_examiner);
      let claimId = $('#claim_id').val() ;
      $.get('/get-examiner-rate/' + examinerId + '/' + feeScheduleId + '/' + claimId, function(response) {
        const examinerFee = response.examiner_fee;
        $('#examiner_fee_amount').text(examinerFee ?? 0);

        // Disable pay_examiner radio button if examiner fee is zero
        if (examinerFee == 0) {
          $('input[name=examiner_fee][value=1]').attr('disabled', true);
          $('input[name=examiner_fee][value=0]').prop('checked', true).change();
        } else {
          $('input[name=examiner_fee][value=1]').attr('disabled', false);
          $('input[name=examiner_fee][value=1]').prop('checked', pay_examiner.length === 0 ? true : pay_examiner).change();
        }
      });
    });

// Update examiner and fee schedule on change event
    $('#examiner_id, #fee_schedule_id').on('change', function() {
      let examinerId = $('#examiner_id').val() ? $('#examiner_id').val() : 0;
      let feeScheduleId = $('#fee_schedule_id').val();
      let claimId = $('#claim_id').val();
      $.get('/get-examiner-rate/' + examinerId + '/' + feeScheduleId + '/' + claimId, function(response) {
        const examinerFee = response.examiner_fee;
        $('#examiner_fee_amount').text(examinerFee ?? 0);

        // Disable pay_examiner radio button if examiner fee is zero
        if (examinerFee == 0) {
          $('input[name=examiner_fee][value=1]').attr('disabled', true).prop('checked', false).change();
          $('input[name=examiner_fee][value=0]').prop('checked', true).change();
        } else {
          $('input[name=examiner_fee][value=1]').attr('disabled', false).prop('checked', true).change();
          $('input[name=examiner_fee][value=0]').prop('checked', false).change();
        }

      });
    });

    $(':radio[name=apply_sales_tax]').on('change', function (e) {
      _this.calculateTotal();
    });

    $(':radio[name=bill_client]').on('change', function (e) {
      _this.calculateTotal();
    });

    $('#estimate').on('keyup', function (e) {
      _this.calculateTotal();
    });

    $('#admin_fee').on('keyup', function (e) {
      _this.calculateTotal();
    });

    $('#additional_adj_fee').on('keyup', function (e) {
      _this.calculateTotal();
    });

    $('#adjuster_rate').on('keyup', function (e) {
      _this.calculateTotal();
    });

    $('#holdback').on('keyup', function (e) {
      _this.calculateTotal();
    });

    $('#discount').on('keyup', function (e) {
      _this.calculateTotal();
    });
  }

  updateFeeScheduleBasedItems(data) {
    let $radio = $(':radio[name=adjuster_billing][value=default]');
    let $label = $radio.closest('label');
    let $text = (data.adjuster_billing === 'tier' ? 'Tiered' : 'Percentage') + ' (fee schedule)';
    $radio.detach();
    $label.text($text).prepend($radio);

    $radio = $(":radio[name=bill_client][value='']");
    $label = $radio.closest('label');
    $text = (data.bill_client === false ? 'No' : 'Yes') + ' (fee schedule)';
    $radio.detach();
    $label.text($text).prepend($radio);
  }

  calculateTotal() {
    if (!this.requestingTotal && this.formInitialized) {
      let now = (new Date()).valueOf();
      let delta = now - this.requestTotalLatest;
      if (delta < 1000) {
        this.requestingTotal = true;
        let _this = this;
        setTimeout(function () {
          _this.requestingTotal = false;
          _this.requestTotalLatest = now;
          _this.requestTotal();
        }, 1000 - delta);
      }
      else {
        this.requestTotalLatest = now;
        this.requestTotal();
      }
    }
  }

  requestTotal() {
    let url = $('#calculate_route_url').val();
    let $invoice_total = $('#invoice_total');
    if (url === undefined || !$invoice_total.length) return;

    let formData = this.$form.serializeArray();

    for (let item of formData) {
      if (item.name === '_method') {
        item.value = 'POST';
        break;
      }
    }

    let total = 'N/A';

    axios.post(url, $.param(formData))
      .then(function (response) {
        if (response.data && (response.data.total !== undefined)) {
          total = numeral(response.data.total).format('$0,0.00');
        }
      })
      .catch(function (error) {
        total = 'N/A';
      })
      .finally(() => {
        $invoice_total.text(total);
      });
  }

  load() {
    this.init();
    this.calculateTotal();
  }
}

export default new InvoiceForm();
